export const PAYMENT_CONTENT_MODE = {
  VIEW: 'view',
  EDIT: 'edit'
};
